import 'jquery-modal';

$('a[data-modal]').click(function(event) {
    $(this).modal({
        fadeDuration: 200
    });
    return false;
});

/// Modal navigation
$('.modal').each(function() {
    var nextid = $(this)
        .next('.modal')
        .attr('id');
    var previd = $(this)
        .prev('.modal')
        .attr('id');
    $(this)
        .find('.modal-nav--right')
        .attr('href', '#' + nextid);
    $(this)
        .find('.modal-nav--left')
        .attr('href', '#' + previd);
    if (jQuery.type(nextid) === 'undefined') {
        $(this)
            .find('.modal-nav--right')
            .addClass('disabled');
    }
    if (jQuery.type(previd) === 'undefined') {
        $(this)
            .find('.modal-nav--left')
            .addClass('disabled');
    }
});
